import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLanguage);
  };

  return (
    <SwitcherContainer onClick={toggleLanguage} title={t('navigation.language.switch')}>
      <LanguageButton active={currentLanguage === 'fr'} title={t('navigation.language.french')}>FR</LanguageButton>
      <Divider>/</Divider>
      <LanguageButton active={currentLanguage === 'en'} title={t('navigation.language.english')}>EN</LanguageButton>
    </SwitcherContainer>
  );
};

const SwitcherContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  transition: all ${({ theme }) => theme.affiliate.animationDuration};
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }
`;

const LanguageButton = styled.span`
  font-size: 0.9rem;
  font-weight: ${({ active }) => (active ? '600' : '400')};
  color: ${({ active, theme }) => 
    active 
      ? theme.affiliate.colors.accent 
      : theme.affiliate.colors.text.contrast.dark
  };
  transition: color ${({ theme }) => theme.affiliate.animationDuration};
`;

const Divider = styled.span`
  margin: 0 5px;
  opacity: 0.5;
  color: ${({ theme }) => theme.affiliate.colors.text.contrast.dark};
`;

export default LanguageSwitcher;